import { EAnalyticMode } from '~/modules/analytics/types';

import { create } from 'zustand';

export interface IOrderListingStoreState {
  mode: EAnalyticMode;
  prevLocation?: string;
  setMode: (mode: EAnalyticMode) => void;
  setPrevLocation: (prevLocation: string) => void;
}

export const useOrderListingStore = create<IOrderListingStoreState>()((set) => ({
  mode: EAnalyticMode.ALL_SESSION,
  setMode: (mode) => set({ mode }),
  prevLocation: undefined,
  setPrevLocation: (prevLocation) => set({ prevLocation }),
}));
